
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/RBhu/[...slug]",
      function () {
        return require("private-next-pages/RBhu/[...slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/RBhu/[...slug]"])
      });
    }
  